import React, { useEffect, useState } from 'react';

import { productApi as api } from 'api/product';
import { DataTable, Notifications } from 'shared';

function ViewCohort() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });

    const columns = [
        { accessor: 'id', Header: 'ID' },
        { accessor: 'name', Header: 'Name', editable: true },
        { accessor: 'description', Header: 'Description', editable: true },
    ];

    const getCohorts = async () => {
        const response = await api.getCohorts();
        if (response.status === false) {
            setNotification({
                text: `Could not load cohorts${response.msg ? `: ${response.msg}` : ''}`,
                level: 'error',
            });
            setRows([]);
            return;
        }

        setRows(response.data.rows ?? []);
    };

    useEffect(() => {
        getCohorts();
    }, []);

    return (
        <div>
            <h1>Cohorts</h1>
            <Notifications options={notification} />
            {}
            <div>
                <DataTable
                    columns={columns}
                    data={rows}
                    editable
                    saveEdit={async ({ field, id, value }) => {
                        const payload = { [field]: value };
                        const res = await api.updateCohort(id, payload);
                        if (!res.status) {
                            setNotification({ text: res.msg, level: 'error' });
                            return false;
                        }

                        setNotification({ text: 'Cohort updated', level: 'success' });
                        getCohorts();
                        return true;
                    }}
                />
            </div>
        </div>
    );
}

export { ViewCohort };
